(() => {
  if (window.__shopVideoLightboxInit) return;
  window.__shopVideoLightboxInit = true;

  const dialog = document.createElement('dialog');
  dialog.className = 'shop-video-lightbox';
  dialog.setAttribute('aria-label', 'Video player');
  dialog.innerHTML = `
    <div class="shop-video-lightbox__panel">
      <button type="button" class="shop-video-lightbox__close" data-shop-video-lightbox-close aria-label="Close">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true">
          <path d="M18 6L6 18M6 6l12 12"/>
        </svg>
      </button>
      <button type="button" class="shop-video-lightbox__nav shop-video-lightbox__nav--prev" data-shop-video-lightbox-prev aria-label="Previous video">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M15 18l-6-6 6-6"/>
        </svg>
      </button>
      <div class="shop-video-lightbox__stage">
        <video
          class="shop-video-lightbox__player"
          controls
          playsinline
          controlsList="nodownload"
          preload="metadata"
        ></video>
        <p class="shop-video-lightbox__caption" data-shop-video-lightbox-caption hidden></p>
      </div>
      <button type="button" class="shop-video-lightbox__nav shop-video-lightbox__nav--next" data-shop-video-lightbox-next aria-label="Next video">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M9 18l6-6-6-6"/>
        </svg>
      </button>
    </div>
  `;

  document.body.appendChild(dialog);

  const player = dialog.querySelector('.shop-video-lightbox__player');
  const captionEl = dialog.querySelector('[data-shop-video-lightbox-caption]');
  const prevBtn = dialog.querySelector('[data-shop-video-lightbox-prev]');
  const nextBtn = dialog.querySelector('[data-shop-video-lightbox-next]');
  let group = [];
  let index = 0;

  const getTriggers = (groupId) =>
    Array.from(
      document.querySelectorAll(`[data-shop-video-lightbox-trigger][data-shop-video-lightbox-group="${groupId}"]`)
    );

  const pauseInlineVideos = () => {
    document.querySelectorAll('[data-shop-video-card] video').forEach((video) => {
      video.pause();
      video.closest('[data-shop-video-card]')?.classList.remove('is-playing');
    });
  };

  const updateNav = () => {
    const showNav = group.length > 1;
    prevBtn.hidden = !showNav;
    nextBtn.hidden = !showNav;
    prevBtn.disabled = !showNav;
    nextBtn.disabled = !showNav;
  };

  const show = () => {
    const trigger = group[index];
    if (!trigger || !player) return;

    const src = trigger.dataset.shopVideoLightboxSrc || trigger.querySelector('video')?.currentSrc || trigger.querySelector('video')?.src || '';
    const label = trigger.dataset.shopVideoLightboxLabel || trigger.querySelector('video')?.getAttribute('aria-label') || '';

    player.pause();
    player.src = src;

    if (captionEl) {
      if (label) {
        captionEl.textContent = label;
        captionEl.hidden = false;
      } else {
        captionEl.textContent = '';
        captionEl.hidden = true;
      }
    }

    updateNav();

    const playPromise = player.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {});
    }
  };

  const open = (trigger) => {
    const groupId = trigger.dataset.shopVideoLightboxGroup;
    if (!groupId) return;

    group = getTriggers(groupId);
    index = group.indexOf(trigger);
    if (index < 0) {
      index = parseInt(trigger.dataset.shopVideoLightboxIndex, 10) || 0;
    }

    pauseInlineVideos();
    show();

    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    }
  };

  const close = () => {
    if (player) {
      player.pause();
      player.removeAttribute('src');
      player.load();
    }

    if (dialog.open) dialog.close();
  };

  const step = (delta) => {
    if (group.length <= 1) return;
    index = (index + delta + group.length) % group.length;
    show();
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-shop-video-lightbox-trigger]');
    if (trigger) {
      event.preventDefault();
      open(trigger);
      return;
    }

    if (event.target.closest('[data-shop-video-lightbox-close]')) {
      event.preventDefault();
      close();
      return;
    }

    if (event.target.closest('[data-shop-video-lightbox-prev]')) {
      event.preventDefault();
      step(-1);
      return;
    }

    if (event.target.closest('[data-shop-video-lightbox-next]')) {
      event.preventDefault();
      step(1);
    }
  });

  dialog.addEventListener('cancel', (event) => {
    event.preventDefault();
    close();
  });

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) close();
  });

  dialog.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      event.preventDefault();
      close();
    } else if (event.key === 'ArrowLeft') {
      event.preventDefault();
      step(-1);
    } else if (event.key === 'ArrowRight') {
      event.preventDefault();
      step(1);
    }
  });
})();
